export interface StatusDef {
  /** Valor de `Estatus` que devuelve el backend en /status-loads-cards */
  key: string;
  /** Etiqueta a mostrar (según Figma) */
  label: string;
  color: string;
}

/** Orden y colores de las tarjetas de status (sin Total, que se calcula). */
export const STATUS_DEFS: StatusDef[] = [
  { key: 'Unassigned', label: 'Unassigned', color: '#f5a623' },
  { key: 'Assigned', label: 'Assigned', color: '#f5a623' },
  { key: 'Waiting to be loaded', label: 'Waiting Load', color: '#00a2ae' },
  { key: 'On Transit', label: 'On Transit', color: '#2f9fd0' },
  { key: 'At Destination', label: 'At Destination', color: '#5cb85c' },
  { key: 'Completed', label: 'Completed', color: '#22a04a' },
  { key: 'Dry run', label: 'Dry Run', color: '#ef4444' },
];

export const TOTAL_COLOR = '#3a3f45';

/** Token canónico de un status, robusto a variantes de nombre (key o display). */
export const canonStatus = (name?: string): string => {
  if (!name) return '';
  const n = name.trim().toLowerCase();
  if (n === 'unassigned') return 'unassigned';
  if (n === 'assigned') return 'assigned';
  if (n === 'waiting to be loaded' || n === 'awaiting load') return 'awaiting';
  if (n === 'on transit') return 'ontransit';
  if (n === 'at destination') return 'atdestination';
  if (n === 'completed') return 'completed';
  if (n === 'dry run') return 'dryrun';
  return n;
};

/** Color del pill de status en la tabla, robusto a variantes de nombre. */
export const statusColorByName = (name?: string): string => {
  if (!name) return '#8a8f98';
  const n = name.trim().toLowerCase();
  if (n === 'unassigned' || n === 'assigned') return '#f5a623';
  if (n === 'waiting to be loaded' || n === 'awaiting load') return '#00a2ae';
  if (n === 'on transit') return '#2f9fd0';
  if (n === 'at destination') return '#5cb85c';
  if (n === 'completed') return '#22a04a';
  if (n === 'dry run') return '#ef4444';
  return '#8a8f98';
};
